// src/components/Navbar.jsx
import React, { useState, useContext, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import CartIcon from "./CartIcon";
import BurgerMenu from "./BurgerMenu";
import Search from "./Search";
import { ShopContext } from "../context/shopContext";
import MarketSwitcher from "./MarketSwitcher";
import { DesktopMainMenu } from "./MainMenu";

function Navbar({ navRef, offsetTop = 0, onToggleMenu, menuOpen }) {
  const [searchOpen, setSearchOpen] = useState(false);
  const { cartCount } = useContext(ShopContext);
  const searchRef = useRef(null);

  const toggleSearch = () => setSearchOpen((v) => !v);

  useEffect(() => {
    const onDocClick = (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setSearchOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  return (
    <div
      ref={navRef}
      className="
        fixed left-0 right-0 
        w-full flex items-center justify-between 
        px-8 py-2 
        bg-white md:bg-transparent 
        z-[11000]
      "
      style={{ top: offsetTop }}
    >
      {/* LEFT AREA — main menu desktop / burger mobile */}
      <div className="flex items-center w-1/4">
        {/* Burger ONLY on mobile */}
        <button
          onClick={onToggleMenu}
          aria-expanded={!!menuOpen}
          aria-controls="overlay-menu"
          className="focus:outline-none md:hidden mt-2"
        >
          <BurgerMenu />
        </button>

        {/* Desktop main menu (now on the left) */}
        <div className="hidden md:block">
          <DesktopMainMenu />
        </div>
      </div>

      {/* CENTER — logo on all breakpoints */}
      <div className="flex-grow flex justify-center">
        <Link to="/home" aria-label="Go to homepage">
          <img
            src="https://cdn.sanity.io/images/ckt2iy7e/production/91b105e5947a1cf8138e65cc9870415a3a09c1ed-2722x496.webp"
            alt="This Belongs To"
            className="h-10 mx-auto"
          />
        </Link>
      </div>

      {/* RIGHT — MarketSwitcher, Search, Cart */}
      <div className="flex items-center justify-end w-1/4 space-x-4">
        <div className="hidden md:inline-flex items-center">
          <MarketSwitcher />
        </div>

        <button
          onClick={toggleSearch}
          className="text-xs uppercase focus:outline-none mr-2 hidden md:inline-block italic"
          aria-expanded={searchOpen}
          aria-controls="site-search"
        >
          {searchOpen ? "Close" : "Search"}
        </button>

        <CartIcon cartCount={cartCount} />
      </div>

      {/* Search overlay */}
      {searchOpen && (
        <div ref={searchRef}>
          <Search closeSearch={() => setSearchOpen(false)} />
        </div>
      )}
    </div>
  );
}

export default Navbar;
